module.exports = __webpack_public_path__ + "static/img/top8.2735924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top8.png
// module id = YzUV
// module chunks = 208